import { useMemo } from "react";
import messages from "./translations/messages";
import createTranslator from "../../../util/translationHelper";

function useFooter() {
  const translate = useMemo(() => {
    return createTranslator(messages);
  }, [createTranslator, messages]);

  return {
    translate,
  };
}

const Hook = {
  useFooter,
};

export default Hook;
